import { CONFIGS } from "../../../configs";

async function getInitialRolloverAvailableDays(alias, lang, brand) {
    const packageGatewaysAPI = CONFIGS.PACKAGES.GATEWAYS.replace("{lang}", lang)
        .replace("{brand}", brand)
        .replace("{alias}", alias);

    const response = await fetch(packageGatewaysAPI);
    const { Options } = await response.json();
    
    return Options
}

export { getInitialRolloverAvailableDays }
export default getInitialRolloverAvailableDays